// extracted by mini-css-extract-plugin
export default {"container":"term_container__hXyqw","content":"term_content__t2tDU"};